import {
    AddOpportunityLink,
    AddUnusual,
    DeleteOpportunity,
    DeleteOpportunityLink,
    QueryActionCount,
    QueryActionSelfCount,
    QueryActionSubCount,
    QueryAnalayArea,
    QueryAnalyseCustomer,
    QueryAnalyseTarget,
    QueryAnalyseUser,
    QueryAreaBoard,
    QueryAreaCustCount,
    QueryAreaDash,
    QueryAreaDashCust,
    QueryAreaDashUser,
    QueryAreaIncome,
    QueryAreaTargetCount,
    QueryAuthBoard,
    QueryAuthCompanyAreaBoard,
    QueryAuthCompanyUserBoard,
    QueryBoard,
    QueryBoardCustomer,
    QueryBottomData,
    QueryBottomUserData,
    QueryCompanyAreaBoard,
    QueryCompanyCustomerBorad,
    QueryCompanyUserBoard,
    QueryCompareMonth,
    QueryCompareYear,
    QueryContractCount,
    QueryCustomerBoard,
    QueryCustomerCount,
    QueryCustomerList,
    QueryForecastSettlement,
    QueryIncomeBoradCustomer,
    QueryIncomeBoradCustomerArea,
    QueryIncomeBoradCustomerUser,
    QueryIncomeBudget,
    QueryIncomeBudgetcCompelete,
    QueryIncomeBudgetComplete,
    QueryIncomeForecast,
    QueryMarketDevelop,
    QueryMarketIncome,
    QueryMarketingCustomer,
    QueryMarketingUser,
    QueryMarketPayment,
    QueryMonthIncome,
    QueryOpportunityInfo,
    QueryOpportunityLink,
    QueryOpportunityPage,
    QueryOpportunityySumWeight,
    QueryOppotunityCount,
    QueryPlanSelfCount,
    QueryPlanSubCount,
    QuerySettleDate,
    QueryTopData,
    QueryUnusualList,
    QueryUserBoard,
    QueryUserIncome,
    QueryVisitSelfCount,
    QueryVisitSubCount,
    SaveOpportunity,
    SubmitOpportunityFlow,
    UpdateAllWeight,
    UpdateConfigDate,
    UpdateNotTransferFlag,
    UpdateOpportunity,
    UpdateOpportunityFlag,
    UpdateOpportunityLink,
    UpdateTransferCustomer,
    UpdateTransferFlag,
    UpdateUnusual
} from '@/request/dashborad';
import { QueryBaseCustomer } from '@/request/income';
import { QueryIncomeBudgetError, QueryReturnBudget, QueryReturnBudgetComplete, QueryVisitCount } from '../../request/dashborad';
import { QueryDashArea } from '@/request/compoent';

export default {
    namespace: true,

    state: {
        analysisAreaData: [],
        analysisAreaCust: [],
        custCount: {},
        subCount: {},
        selfCount: {},
        subPlanCount: {},
        selfPlanCount: {},
        contractCount: {},
        oppCount: {},
        selfVisitCount: {},
        subVisitCount: {}
    },

    mutations: {
        SET_STATE(state, prop) {
            state = {
                ...state,
                ...prop
            };
        },
        SET_ANALAY_AREA_DATA(state, analysisAreaData) {
            state.analysisAreaData = analysisAreaData;
        },

        SET_ANALYSIS_CUST(state, analysisCust) {
            state.analysisCust = analysisCust;
        },
        SET_CUSTOMER_COUNT(state, count) {
            state.custCount = count;
        },
        SET_ACTION_SUB_COUNT(state, count) {
            state.subCount = count;
        },
        SET_ACTION_SELF_COUNT(state, count) {
            state.selfCount = count;
        },
        SET_PLAN_SUB_COUNT(state, count) {
            state.subPlanCount = count;
        },
        SET_PLAN_SELF_COUNT(state, count) {
            state.selfPlanCount = count;
        },
        SET_VISIT_SUB_COUNT(state, count) {
            state.subVisitCount = count;
        },
        SET_VISIT_SELF_COUNT(state, count) {
            state.selfVisitCount = count;
        },
        SET_CONTRACT_COUNT(state, count) {
            state.contractCount = count;
        },
        SET_OPPORTUNITY_COUNT(state, count) {
            state.oppCount = count;
        }
    },

    actions: {
        UPDATE_STATE: ({ commit }, payload) => {
            commit('SET_STATE', payload);
        },

        UPDATE_ANALAY_AREA_DATA: ({ commit }, payload) => {
            commit('SET_ANALAY_AREA_DATA', payload);
        },

        QUERY_ANALYSIS_DATA: async ({ commit }, payload) => {
            let res = await QueryAnalayArea(payload);
            // if (res?.code == 200) {
            //     commit('SET_ANALAY_AREA_DATA', res.data);
            // }
            return res;
        },

        QUERY_BOARD: async ({ commit }, payload) => {
            let res = await QueryBoard(payload);
            return res;
        },
        QUERY_AREA_BOARD: async ({ commit }, payload) => {
            let res = await QueryAreaBoard(payload);
            return res;
        },

        QUERY_USER_BOARD: async ({ commit }, payload) => {
            let res = await QueryUserBoard(payload);
            return res;
        },

        QUERY_CUSTOMER_BOARD: async ({ commit }, payload) => {
            let res = await QueryCustomerBoard(payload);
            return res;
        },

        // 公司数据
        QUERY_COMPANY_AREA_BOARD: async ({ commit }, payload) => {
            let res = await QueryCompanyAreaBoard(payload);
            return res;
        },

        QUERY_COMPANY_USER_BOARD: async ({ commit }, payload) => {
            let res = await QueryCompanyUserBoard(payload);
            return res;
        },

        QUERY_COMPANY_CUSTOMER_BOARD: async ({ commit }, payload) => {
            let res = await QueryCompanyCustomerBorad(payload);
            return res;
        },

        // 有权限

        QUERY_AUTH_BOARD: async ({ commit }, payload) => {
            let res = await QueryAuthBoard(payload);
            return res;
        },

        QUERY_AUTH_COMPANY_AREA_BORAD: async ({ commit }, payload) => {
            let res = await QueryAuthCompanyAreaBoard(payload);
            return res;
        },

        QUERY_AUTH_COMPANY_USER_BORAD: async ({ commit }, payload) => {
            let res = await QueryAuthCompanyUserBoard(payload);
            return res;
        },

        QUERY_AREA_INCOME: async ({ commit }, payload) => {
            let res = await QueryAreaIncome(payload);
            return res;
        },

        QUERY_USER_INCOME: async ({ commit }, payload) => {
            let res = await QueryUserIncome(payload);
            return res;
        },

        QUERY_MONTH_INCOME: async ({ commit }, payload) => {
            let res = await QueryMonthIncome(payload);
            return res;
        },
        QUERY_BOARD_CUSTOMER: async ({ commit }, payload) => {
            let res = await QueryBoardCustomer(payload);
            return res;
        },
        QUERY_INCOME_BORAD_CUSTOMER_USER: async ({ commit }, payload) => {
            let res = await QueryIncomeBoradCustomerUser(payload);
            return res;
        },
        QUERY_INCOME_BORAD_CUSTOMER_AREA: async ({ commit }, payload) => {
            let res = await QueryIncomeBoradCustomerArea(payload);
            return res;
        },

        // 预估结算对比
        QUERY_FORECAST_SETTLEMENT: async ({ commit }, payload) => {
            let res = await QueryForecastSettlement(payload);
            return res;
        },

        QUERY_SETTLE_DATE: async ({ commit }, payload) => {
            let res = await QuerySettleDate(payload);
            return res;
        },

        UPDATE_CONFIG_DATE: async ({ commit }, payload) => {
            let res = await UpdateConfigDate(payload);
            return res;
        },

        QUERY_UNUSUAL_LIST: async ({}, payload) => {
            let res = await QueryUnusualList(payload);
            return res;
        },

        ADD_UNUSUAL: async ({}, payload) => {
            let res = await AddUnusual(payload);
            return res;
        },
        UPDATE_UNUSUAL: async ({}, payload) => {
            let res = await UpdateUnusual(payload);
            return res;
        },

        // 营销数据
        QUERY_MARKET_INCOME: async ({ commit }, payload) => {
            let res = await QueryMarketIncome(payload);
            return res;
        },

        QUERY_MARKET_PAYMENT: async ({}, payload) => {
            let res = await QueryMarketPayment(payload);
            return res;
        },

        QUERY_MARKET_DEVELOP: async ({}, payload) => {
            let res = await QueryMarketDevelop(payload);
            return res;
        },

        QUERY_MARKETING_CUSTOMER: async ({}, payload) => {
            let res = await QueryMarketingCustomer(payload);
            return res;
        },

        QUERY_MARKETING_USER: async ({}, payload) => {
            let res = await QueryMarketingUser(payload);
            return res;
        },

        // 收入指标完成情况
        QUERY_INCOME_BUDGET_COMPLETE: async ({ commit }, payload) => {
            let res = await QueryIncomeBudgetComplete(payload);
            return res;
        },

        QUERY_INCOME_BUDGET_ERROR: async ({ commit }, payload) => {
            let res = await QueryIncomeBudgetError(payload);
            return res;
        },

        // 回款指标完成情况
        QUERY_RETURN_BUDGET_COMPLETE: async ({ commit }, payload) => {
            let res = await QueryReturnBudgetComplete(payload);
            return res;
        },

        //收入预估
        QUERY_INCOME_FORECAST: async ({}, payload) => {
            let res = await QueryIncomeForecast(payload);
            return res;
        },

        //拜访频率
        QUERY_VISIT_COUNT: async ({}, payload) => {
            let res = await QueryVisitCount(payload);
            return res;
        },

        // 同环比分析
        QUERY_COMPARE_MONTH: async ({}, payload) => {
            let res = await QueryCompareMonth(payload);
            return res;
        },

        QUERY_COMPARE_YEAR: async ({}, payload) => {
            let res = await QueryCompareYear(payload);
            return res;
        },

        QUERY_TOP_DATA: async ({}, payload) => {
            let res = await QueryTopData(payload);
            return res;
        },
        QUERY_BOTTOM_DATA: async ({}, payload) => {
            let res = await QueryBottomData(payload);
            return res;
        },
        QUERY_BOTTOM_USRE_DATA: async ({}, payload) => {
            let res = await QueryBottomUserData(payload);
            return res;
        },
        QUERY_OPPORTUNITY_DATA: async ({}, payload) => {
            let res = await QueryOpportunityPage(payload);
            return res;
        },
        SAVE_OPPORTUNITY_DATA: async ({}, payload) => {
            let res = await SaveOpportunity(payload);
            return res;
        },
        UPDATE_OPPORTUNITY_DATA: async ({}, payload) => {
            let res = await UpdateOpportunity(payload);
            return res;
        },
        DELETE_OPPORTUNITY_DATA: async ({}, payload) => {
            let res = await DeleteOpportunity(payload);
            return res;
        },
        QUERY_OPPORTUNITY_INFO: async ({}, payload) => {
            let res = await QueryOpportunityInfo(payload);
            return res;
        },
        UPDATE_OPPORTUNITY_FLAG: async ({}, payload) => {
            let res = await UpdateOpportunityFlag(payload);
            return res;
        },
        UPDATE_TRANSFER_FLAG: async ({}, payload) => {
            let res = await UpdateTransferFlag(payload);
            return res;
        },
        UPDATE_NOT_TRANSFER_FLAG: async ({}, payload) => {
            let res = await UpdateNotTransferFlag(payload);
            return res;
        },

        UPDATE_TRANSFER_CUSTOMER: async ({}, payload) => {
            let res = await UpdateTransferCustomer(payload);
            return res;
        },
        // 商机提交评估流程
        SUBMIT_OPPORTUNITY_FLOW: async ({}, payload) => {
            let res = await SubmitOpportunityFlow(payload);
            return res;
        },

        //商机联系人
        QUERY_OPPORTUNITY_LINK: async ({}, payload) => {
            let res = await QueryOpportunityLink(payload);
            return res;
        },
        UPDATE_OPPORTUNITY_LINK: async ({}, payload) => {
            let res = await UpdateOpportunityLink(payload);
            return res;
        },
        DELETE_OPPORTUNITY_LINK: async ({}, payload) => {
            let res = await DeleteOpportunityLink(payload);
            return res;
        },
        ADD_OPPORTUNITY_LINK: async ({}, payload) => {
            let res = await AddOpportunityLink(payload);
            return res;
        },
        QUERY_OPPORTUNITY_SUM_WEIGHT: async ({}, payload) => {
            let res = await QueryOpportunityySumWeight(payload);
            return res;
        },
        UPDATE_ALL_WEIGHT: async ({}, payload) => {
            let res = await UpdateAllWeight(payload);
            return res;
        },

        QUERY_ANALYSE_TARGET: async ({}, payload) => {
            let res = await QueryAnalyseTarget(payload);
            return res;
        },
        QUERY_ANALYSE_CUSTOMER: async ({}, payload) => {
            let res = await QueryAnalyseCustomer(payload);
            return res;
        },
        QUERY_CUSTOMER_DASH: async ({}, payload) => {
            let res = await QueryCustomerList(payload);
            return res;
        },

        QUERY_AREA_DASH_CUST: async ({}, payload) => {
            let res = await QueryAreaDashCust(payload);
            return res;
        },
        QUERY_AREA_DASH_USER: async ({}, payload) => {
            let res = await QueryAreaDashUser(payload);
            return res;
        },
        QUERY_AREA_CUST_COUNT: async ({}, payload) => {
            let res = await QueryAreaCustCount(payload);
            return res;
        },
        QUERY_AREA_TARGET_COUNT: async ({}, payload) => {
            let res = await QueryAreaTargetCount(payload);
            return res;
        },
        QUERY_DASH_AREA: async ({}, payload) => {
            let res = await QueryDashArea(payload);
            return res;
        },

        // 首页的统计
        QUERY_CUSTOMER_COUNT: async ({ commit }, payload) => {
            let res = await QueryCustomerCount(payload);
            if (res?.code == 200) {
                commit('SET_CUSTOMER_COUNT', res.data);
            } else {
                commit('SET_CUSTOMER_COUNT', {});
            }
            return res;
        },

        QUERY_CONTRACT_COUNT: async ({ commit }, payload) => {
            let res = await QueryContractCount(payload);
            if (res?.code == 200) {
                commit('SET_CONTRACT_COUNT', res.data);
            } else {
                commit('SET_CONTRACT_COUNT', {});
            }
            return res;
        },

        QUERY_ACTION_SUB_COUNT: async ({ commit }, payload) => {
            let res = await QueryActionSubCount(payload);
            if (res?.code == 200) {
                commit('SET_ACTION_SUB_COUNT', res.data);
            } else {
                commit('SET_ACTION_SUB_COUNT', {});
            }
            return res;
        },

        QUERY_ACTION_SELF_COUNT: async ({ commit }, payload) => {
            let res = await QueryActionSelfCount(payload);
            if (res?.code == 200) {
                commit('SET_ACTION_SELF_COUNT', res.data);
            } else {
                commit('SET_ACTION_SELF_COUNT', {});
            }
            return res;
        },

        QUERY_PLAN_SUB_COUNT: async ({ commit }, payload) => {
            let res = await QueryPlanSubCount(payload);
            if (res?.code == 200) {
                commit('SET_PLAN_SUB_COUNT', res.data);
            } else {
                commit('SET_PLAN_SUB_COUNT', {});
            }
            return res;
        },

        QUERY_PLAN_SELF_COUNT: async ({ commit }, payload) => {
            let res = await QueryPlanSelfCount(payload);
            if (res?.code == 200) {
                commit('SET_PLAN_SELF_COUNT', res.data);
            } else {
                commit('SET_PLAN_SELF_COUNT', {});
            }
            return res;
        },

        QUERY_VISIT_SUB_COUNT: async ({ commit }, payload) => {
            let res = await QueryVisitSubCount(payload);
            if (res?.code == 200) {
                commit('SET_VISIT_SUB_COUNT', res.data);
            } else {
                commit('SET_VISIT_SUB_COUNT', {});
            }
            return res;
        },

        QUERY_VISIT_SELF_COUNT: async ({ commit }, payload) => {
            let res = await QueryVisitSelfCount(payload);
            if (res?.code == 200) {
                commit('SET_VISIT_SELF_COUNT', res.data);
            } else {
                commit('SET_VISIT_SELF_COUNT', {});
            }
            return res;
        },

        QUERY_OPPORTUNITY_COUNT: async ({ commit }, payload) => {
            let res = await QueryOppotunityCount(payload);
            if (res?.code == 200) {
                commit('SET_OPPORTUNITY_COUNT', res.data);
            } else {
                commit('SET_OPPORTUNITY_COUNT', {});
            }
            return res;
        }
    }
};
